import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/siteData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center">
              <i className={`ri-movie-2-fill text-2xl md:text-3xl ${
                scrolled ? 'text-primary-500' : 'text-background-50'
              }`} />
            </div>
            <span
              className={`text-lg md:text-xl font-bold font-heading tracking-wide ${
                scrolled ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 hover:text-primary-500 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-primary-500'
                    : scrolled
                      ? 'text-foreground-700'
                      : 'text-background-50/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-foreground-600 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium py-2 px-3 rounded-lg text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}